export interface CardTextInputViewModel {
    data: string,
    id: number
}

export class CardTextInputViewModel {
    constructor() {

    }
}